import {media} from '@modifi/ui'
import {seaNavy, white} from '@modifi/colors'
import styled from 'styled-components'
import {hexToRgba} from '../common'

export const ImageSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 680px;
  margin: 0 auto;
  overflow: hidden;
  ${media.sm`
    flex-direction: row;
    width: 95%;
    height: 456px;
  `}

  ${media.lg`
    width: 832px;
  `}
`

export const ImageCard = styled.div`
  position: relative;
  flex-grow: 1;
  transition: flex-grow 0.3s;
  overflow: hidden;

  &:hover {
    flex-grow: 3;
    ${media.md`
      flex-grow: 2;
    `}

    > div {
      color: ${white};
      opacity: 1;
    }
  }

  img {
    width: 100%;
    position: absolute;
    top: 64%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${media.sm`
      width: auto;
      height: 100%;
      top: 50%;
    `}
  }
`

export const ImageCardContent = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  position: absolute;
  opacity: 0;
  color: transparent;
  transition: color 0.3s;
  transition-delay: 0.3s;
  background-color: ${hexToRgba(seaNavy, 0.77)};

  @media (max-width: 400px) {
    h6,
    p {
      font-size: 14px;
    }
  }
`
